import axiosConfig from './axiosConfig';

// List rides
export const getRideList = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('ride', { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};

// Create ride
export const createRide = async (rideData) => {
    try {
        const response = await axiosConfig.post('ride', rideData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response;
    } catch (error) {
        throw error || 'Failed to create ride';
    }
};

// Show ride details
export const getRideDetails = async (id) => {
    try {
        const response = await axiosConfig.get(`ride/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Update ride
export const updateRide = async (id, rideData) => {
    try {
        const response = await axiosConfig.put(`ride/${id}`, rideData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response;
    } catch (error) {
        throw error || 'Failed to update ride';
    }
};

// Delete ride
export const deleteRide = async (id) => {
    try {
        const response = await axiosConfig.delete(`ride/${id}`);
        return response;
    } catch (error) {
        throw error || 'Failed to delete ride';
    }
};